import {makeApiCall} from "../../Api/makeApiCall";
export const BETA_GENERATE_MEASURES_DAG_ID = 'measures_generate_measures_bq_beta'

export const isMeasuresBetaAvailable = async () => {
    const url = `${process.env.REACT_APP_EDP_API_BASE_URL}/airflow/api/dags/${BETA_GENERATE_MEASURES_DAG_ID}`;
    return makeApiCall(url).then(result => (result?.is_active === true || result?.is_stale === false) && result?.is_paused === false)
}